import React from 'react';
import version from '../../buildversion.json';
 
export default function AppVersion() {
  return (
    <div className="app-version">
        {`Version ${version.buildMajor}.${version.buildMinor}.${version.buildRevision} ${version.buildTag}`}
    </div>
  );
}
